import axios from 'axios';
import config from '../apiConfig';

/**
 * Sync selected store location with eSTORIS
 * @param {axios cancellation token} cancelToken: use this to cancel a request in progress
 * @param {number} warehouseId - integer (required) NOP warehouse id
 */
const saveSelectedLocation = (cancelToken, warehouseId, customerId) => {
	const instance = axios.create(config);

	return instance.get('SaveSelectedLocation', {
		params: {
			warehouseId,
			customerId,
		},
		cancelToken,
	});
};

// eslint-disable-next-line import/prefer-default-export
export { saveSelectedLocation };
